import React, {useState, useRef, useEffect} from 'react'
import styled from 'styled-components';

import { Paper, Button } from 'components'
import { FaAngleUp, FaAngleDown } from 'react-icons/fa'

import classes from './NumberField.module.css'

const defaultStyle = {
    primaryColor: 'var(--secondary-color)',
    color: 'var(--text-color)',
    padding: '0.1rem 0.2rem 0.1rem 0.5rem',
    margin: 0,
    width: '4rem',
}

const inputStyle = {
    // fontFamily: 'Helvetica Neue', 'Arial', sans-serif;
    fontSize: '0.9rem',
    backgroundColor: 'transparent',
    border: 'none',
    color: 'var(--text-color)',
    resize: 'none',
    overflow: 'none',
    outline: 'none',
    flexGrow: 4,
}

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    flex-grow: 4;
    /* width: 100%; */
    min-width: 2rem;
    border-radius: 5px;
    background-color: ${props => props.style.primaryColor};
    border: ${props => props.error ? '1px solid red' : '1px solid transparent'};
    color: ${props => props.style.color};
    padding: ${props => props.style.padding};
    width: ${props => props.style.width};
`

const Buttons = styled.div`
    display: flex;
    flex-direction: column;
`

const NumberField = props => {
    const {
        value,
        onSubmit,
        onChange,
        style,
        max,
        min
    } = props;
    let updatedStyle = Object.assign({}, defaultStyle, style)
    let updatedInputStyle = Object.assign({}, inputStyle, style)
    updatedStyle['margin'] = 0
    updatedInputStyle['margin'] = 0

    const [i, setValue] = useState(value || 0)
    const [error, setError] = useState(false)
    const inputRef = useRef(null);
    useEffect(() => {
        onChange && onChange(i)
    }, [i]);

    const buttonStyle = {
        backgroundColor: style && style.secondaryColor || 'var(--primary-color)',
        margin: 0,
        padding: '0.1rem',
        fontSize: '0.5rem',
    }

    const changeValue = val => {
        if(max !== null && min !== null){
            if(val <= max & val >= min){
                setValue(val)
                error && setError(false)
            } else {
                setError(true)
            }
        } else {
            setValue(val)
            error && setError(false)
        }
    }

    return (
        <Container style={updatedStyle} error={error}>
            <input type='number' style={updatedInputStyle} max={max || 999} min={min || 1} onChange={(event) => changeValue(event.target.value)}
                ref={inputRef} value={i}/>
            <Buttons>
                <Button icon={<FaAngleUp/>} styles={buttonStyle} onSelect={() => changeValue(i+1)}/>
                <Button icon={<FaAngleDown/>} styles={buttonStyle} onSelect={() => changeValue(i-1)}/>
            </Buttons>
        </Container>
    )
}

export default NumberField